import { ArrowRight, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative bg-gradient-to-br from-gray-dark via-gray-medium to-gray-dark text-white py-20 md:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div 
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: 'url(/images/ays-be-BD4pN-2zw7s-unsplash.webp)' }}
        ></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl">
          <div className="flex items-center space-x-2 mb-4">
            <Sparkles className="text-yellow-accent" size={24} />
            <span className="text-yellow-accent font-semibold">Your Trusted Casino Guide</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Find Your Perfect
            <span className="text-yellow-accent block">Casino Match</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed">
            We've done the research so you don't have to. Compare top UK casinos, 
            unlock exclusive bonuses, and start winning smarter today.
          </p>
          
          <div className="flex flex-wrap gap-3 mb-8">
            <a
              href="#offers"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              Offers
            </a>
            <a
              href="#about"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              About Us
            </a>
            <a
              href="#guides"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              Guides
            </a>
            <a
              href="#faq"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              FAQ
            </a>
            <a
              href="#news"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              News
            </a>
            <a
              href="#contact"
              data-discover="true"
              className="bg-white/10 backdrop-blur-sm text-white px-4 py-2 rounded-lg font-semibold text-sm hover:bg-white/20 transition-all border border-white/20"
            >
              Contact
            </a>
          </div>
          
         
        </div>
      </div>
    </section>
  );
};

export default Hero;

